import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastController } from '@ionic/angular';
import { DataService } from '../../data.service';
import { modeNev } from '../../mode-nevek';

// Admin → Intézmény → Alapértelmezett intézmény/alrendszer. Ha egy felhasználónak több feladatellátása
// (intézmény/alrendszer) van, itt állítható be, melyik nyíljon meg belépéskor:
//  - „Mindenkinek" = feladatellatas.alapertelmezett (intézményi, minden felhasználóra)
//  - „Nekem"       = allomany_feladatellatas.alapertelmezett (csak a belépett fiókra)
// Precedencia belépéskor: a user saját választása > intézményi alapértelmezett > főállás.
@Component({
  selector: 'app-alapertelmezett-intezmeny',
  templateUrl: './alapertelmezett-intezmeny.component.html',
  styleUrls: ['./alapertelmezett-intezmeny.component.scss'],
})
export class AlapertelmezettIntezmenyComponent implements OnInit {
  modeNev = modeNev;
  user = '';
  betolt = false;
  fut = false;
  intezmenyek: any[] = [];

  constructor(private http: HttpClient, private data: DataService, private toast: ToastController) {}

  async ngOnInit() {
    const u = await this.data.getFromStorage('user');
    const um = await this.data.getFromStorage('userMetadata');
    this.user = u?.username || um?.adid || '';
    await this.betoltMind();
  }

  async betoltMind() {
    if (!this.user) return;
    this.betolt = true;
    try {
      const res: any = await this.http.get(`/api/user/${this.user}`).toPromise();
      let arr: any[] = [];
      try { arr = JSON.parse(res?.[0]?.intezmenyadatok || '[]'); } catch { arr = []; }
      this.intezmenyek = (arr || []).filter((d) => d.kulso == 0).map((d) => {
        // a mode nyers JSON-string (f.mode) – tömbbé alakítjuk a legördülőhöz
        if (typeof d.mode === 'string') { try { d.mode = JSON.parse(d.mode); } catch { d.mode = []; } }
        if (!Array.isArray(d.mode)) d.mode = [];
        // a legördülő az effektív alapértelmezett alrendszert (COALESCE(af.alap_mode,f.mainmode)) mutatja
        d.valasztottMode = d.mainmode || d.mode[0] || '';
        return d;
      });
    } catch { this.intezmenyek = []; }
    this.betolt = false;
  }

  // Felhasználónkénti (a belépett fiókra): intézmény + a kiválasztott ALRENDSZER. Toggle: ha már ez, törlés.
  async nekem(i: any) {
    this.fut = true;
    const mar = i.alapertelmezett_user == 1;
    try {
      // A feladatellatas-id per-jelet tartalmazhat (pl. '203508/001') → NYERSEN (a route :feladatellatas(*)).
      await this.http.put(`/api/user-alapertelmezett/${encodeURIComponent(this.user)}/${mar ? '0' : i.intezmenyId}`, {}).toPromise();
      // az alrendszer-felülírás: beállításkor a választott mode, törléskor üres (vissza az intézményire)
      await this.http.put(`/api/user-mainmode/${encodeURIComponent(this.user)}/${i.intezmenyId}`, { mode: mar ? '' : (i.valasztottMode || '') }).toPromise();
      await this.uzen(mar ? 'Egyéni alapértelmezett törölve.' : 'Beállítva – neked ez az intézmény/alrendszer nyílik meg belépéskor.', 'success');
      await this.betoltMind();
    } catch (e: any) { await this.uzen(e?.error?.error || 'Nem sikerült menteni.', 'danger'); }
    this.fut = false;
  }

  // Intézmény-szintű (mindenkinek): intézmény-default + a kiválasztott ALRENDSZER (f.mainmode).
  async mindenkinek(i: any) {
    this.fut = true;
    try {
      await this.http.put(`/api/intezmeny-alapertelmezett/${i.intezmenyId}`, {}).toPromise();
      if (i.valasztottMode) {
        await this.http.put(`/api/intezmeny-mainmode/${i.intezmenyId}`, { mode: i.valasztottMode }).toPromise();
      }
      await this.uzen('Beállítva – minden felhasználónak ez az intézmény/alrendszer nyílik meg belépéskor.', 'success');
      await this.betoltMind();
    } catch (e: any) { await this.uzen(e?.error?.error || 'Nem sikerült menteni.', 'danger'); }
    this.fut = false;
  }

  private async uzen(m: string, c: string) { (await this.toast.create({ message: m, duration: 2600, color: c })).present(); }
}
